import { Text } from "@sundaeswap/ui-toolkit";
import { FC } from "react";

export const NoWalletsIndicator: FC = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8">
      <Text tag="h3" size="lg" weight="medium">
        No Wallets Detected
      </Text>
      <Text tag="p" size="sm" className="text-center text-silent-200">
        Please install a Cardano wallet extension to connect. Popular options
        include Eternl, Lace, or Yoroi.
      </Text>
    </div>
  );
};

export default NoWalletsIndicator;
